import { ReactElement, SVGFactory } from 'react';
import { FormattedMessage } from 'react-intl';
import BankImg from '@/common/svg/bank-img.svg';
import ClockGears from '@/common/svg/clock-gears-img.svg';
import DocumentImg from '@/common/svg/document-img.svg';
import PercentImg from '@/common/svg/percent-image.svg';
import ShopDiscountImg from '@/common/svg/shop-discount-img.svg';

interface Props {
  message: ReactElement;
  Image: SVGFactory;
}

export const advantagesModel: Props[][] = [
  [
    {
      message: <FormattedMessage defaultMessage="0% на первые 7 дней всегда" />,
      Image: PercentImg,
    },
    {
      message: <FormattedMessage defaultMessage="Без залога и поручителей" />,
      Image: ShopDiscountImg,
    },
    {
      message: <FormattedMessage defaultMessage="10 минут на рассмотрение" />,
      Image: ClockGears,
    },
  ],
  [
    {
      message: (
        <FormattedMessage defaultMessage="Зачисление денег на счет любого банка" />
      ),
      Image: BankImg,
    },
    {
      message: (
        <FormattedMessage defaultMessage="Личные данные под надежной защитой" />
      ),
      Image: DocumentImg,
    },
  ],
];
